import api from "./api";

const getError = (error, fallback) => error.response?.data?.message || error.response?.data?.error || fallback;

async function getUsers(role, search = "") {
  try {
    const { data } = await api.get("/api/communication/users", { params: { role, search } });
    return { success: true, data };
  } catch (error) {
    return { success: false, error: getError(error, "Could not load users") };
  }
}

async function getConversations(params = {}) {
  try {
    const { data } = await api.get("/api/communication/conversations", { params });
    return { success: true, data };
  } catch (error) {
    return { success: false, error: getError(error, "Could not load conversations") };
  }
}

async function getAdminChat() {
  try {
    const { data } = await api.get("/api/communication/admin-chat");
    return { success: true, data };
  } catch (error) {
    return { success: false, error: getError(error, "Could not open admin chat") };
  }
}

async function getConversation(conversationId) {
  try {
    const { data } = await api.get(`/api/communication/conversations/${conversationId}`);
    return { success: true, data };
  } catch (error) {
    return { success: false, error: getError(error, "Could not load conversation") };
  }
}

async function sendMessage(payload) {
  try {
    const { data } = await api.post("/api/communication/messages", payload);
    return { success: true, data };
  } catch (error) {
    return { success: false, error: getError(error, "Could not send message") };
  }
}

async function sendAnnouncement(payload) {
  try {
    const { data } = await api.post("/api/communication/announcements", payload);
    return { success: true, data };
  } catch (error) {
    return { success: false, error: getError(error, "Could not send announcement") };
  }
}

async function getNotifications() {
  try {
    const { data } = await api.get("/api/communication/notifications", { skipAuthRedirect: true });
    return { success: true, data };
  } catch (error) {
    return { success: false, error: getError(error, "Could not load notifications") };
  }
}

async function getUnreadCount() {
  try {
    const { data } = await api.get("/api/communication/notifications/unread-count", { skipAuthRedirect: true });
    return { success: true, data: data?.count || 0 };
  } catch (error) {
    return { success: false, error: getError(error, "Could not load notification count") };
  }
}

async function markNotificationRead(notificationId) {
  try {
    await api.post(`/api/communication/notifications/${notificationId}/read`);
    return { success: true };
  } catch (error) {
    return { success: false, error: getError(error, "Could not update notification") };
  }
}

export const communicationService = {
  getUsers,
  getConversations,
  getAdminChat,
  getConversation,
  sendMessage,
  sendAnnouncement,
  getNotifications,
  getUnreadCount,
  markNotificationRead
};
